module.exports = __webpack_public_path__ + "static/media/bharath_2.29154f7c.png";